// Stick Stories — Template metadata
// Cohesive product names for the two ranges + their color variants.
// Variant primary / secondary colors are also the "preset palettes" customers
// can pick if they don't want to use the chromatic wheels.

const TP = {
  anthologie: {
    id: 'anthologie',
    pdfSlug: 'tp4',
    name: 'Édition I',
    tagline: 'Édition album',
    desc: "Un livre éditorial, plus posé : grandes photos plein cadre, mises en page asymétriques. Pour les chapitres famille, voyage, et histoires d'amour.",
    variants: [
      { id: 'rs', name: 'Rose',          primary: '#F8D8D8', secondary: '#B87880' },
      { id: 'bb', name: 'Beige & Bleu',  primary: '#E8DBC2', secondary: '#6098B8' },
      { id: 'jr', name: 'Jaune & Rouge', primary: '#F0F2B8', secondary: '#901820' },
      { id: 'rm', name: 'Rose & Marron', primary: '#F0D0E0', secondary: '#583820' },
      { id: 'og', name: 'Orange & Gris', primary: '#F0A878', secondary: '#4A4A4A' },
    ],
  },
  mosaique: {
    id: 'mosaique',
    pdfSlug: 'tp3',
    name: 'Édition II',
    tagline: 'Édition vignettes',
    desc: "Une mosaïque de moments à coller : vignettes numérotées, pages thématiques, ambiance carnet de collection.",
    // Couleurs échantillonnées directement depuis les PDFs.
    variants: [
      { id: 'jr', name: 'Jaune & Rose',           primary: '#F2E36A', secondary: '#C81048' },
      { id: 'bo', name: 'Bleu & Orange',          primary: '#7CCBE6', secondary: '#F89060' },
      { id: 'vr', name: 'Vert & Rose',            primary: '#138068', secondary: '#F87890' },
      { id: 'va', name: "Vert d'eau & Aubergine", primary: '#98D0C8', secondary: '#5C2A4C' },
      { id: 'nb', name: 'Noir & Blanc',           primary: '#1F1F1F', secondary: '#E8E8E8' },
    ],
  },
  triptyque: {
    id: 'triptyque', name: 'Édition III', tagline: 'Edition 3 couleurs', colorCount: 3,
    desc: 'Trois teintes, une mise en page rythmee.',
    pdfSlug: 'tp5',
    variants: [
      { id: 'p5a', name: 'Bleu & violet',    primary: '#4A8AC4', secondary: '#7B5EA7', tertiary: '#F0CC40' },
      { id: 'p5b', name: 'Vert & creme',     primary: '#4A7C59', secondary: '#5C3D2E', tertiary: '#F0E8D0' },
      { id: 'p5c', name: 'Rouge & gris',     primary: '#C04040', secondary: '#808080', tertiary: '#F0F0F0' },
      { id: 'p5d', name: 'Rose & orange',    primary: '#E8A0B0', secondary: '#E07840', tertiary: '#909090' },
      { id: 'p5e', name: 'Bordeaux & jaune', primary: '#8C2040', secondary: '#E8C040', tertiary: '#F0E0C0' }
    ]
  },
  eclat: {
    id: 'eclat', name: 'Édition IV', tagline: 'Edition lumineuse', colorCount: 3,
    desc: 'Un design editorial aux couleurs lumineuses.',
    pdfSlug: 'tp6',
    variants: [
      { id: 'p6a', name: 'Violet & beige',   primary: '#8B6BAF', secondary: '#C4A8D8', tertiary: '#F0E8D8' },
      { id: 'p6b', name: 'Bleu & marron',    primary: '#4A6C9C', secondary: '#8C5C3C', tertiary: '#E8D8C8' },
      { id: 'p6c', name: 'Orange & vert',    primary: '#E07840', secondary: '#4A7C59', tertiary: '#F5E8D0' },
      { id: 'p6d', name: 'Rose sunset',      primary: '#E87880', secondary: '#E07840', tertiary: '#F5B060' },
      { id: 'p6e', name: 'Rose & vert',      primary: '#E8A0A8', secondary: '#4A7C59', tertiary: '#F0E8D0' }
    ]
  },
  palette: {
    id: 'palette', name: 'Édition V', tagline: 'Edition 4 couleurs', colorCount: 4,
    desc: 'Quatre teintes pour une mise en page riche et coloree.',
    pdfSlug: 'tp7',
    variants: [
      { id: 'p7a', name: 'Bleu & rouge',        primary: '#4A6C9C', secondary: '#C04040', tertiary: '#E87880', quaternary: '#F0E8D0' },
      { id: 'p7b', name: 'Bleu rouge & jaune',  primary: '#4A6C9C', secondary: '#C04040', tertiary: '#F5D048', quaternary: '#F0E8D0' },
      { id: 'p7c', name: 'Orange & bordeaux',   primary: '#E07840', secondary: '#8C2040', tertiary: '#C8A860', quaternary: '#F0E0C0' },
      { id: 'p7d', name: 'Gris & violet',       primary: '#909090', secondary: '#F5D048', tertiary: '#8C5C3C', quaternary: '#7B5EA7' },
      { id: 'p7e', name: 'Vert & violet',       primary: '#4A7C59', secondary: '#7B5EA7', tertiary: '#9CC0A0', quaternary: '#D0C8E8' }
    ]
  }
};

// 14 categories (with emoji) that the customer can pick.
const CATEGORIES = [
  { id: 'cours',    label: 'Les cours',          emoji: '📚' },
  { id: 'anniv',    label: 'Anniversaire',       emoji: '🎂' },
  { id: 'nye',      label: 'Nouvel an',          emoji: '🎆' },
  { id: 'famille',  label: 'Souvenirs famille',  emoji: '👨\u200d👩\u200d👧\u200d👦' },
  { id: 'amis',     label: 'Les amis',           emoji: '👥' },
  { id: 'passion',  label: 'Passion',            emoji: '❤️' },
  { id: 'sport',    label: 'Sport',              emoji: '⚽' },
  { id: 'travail',  label: 'Travail',            emoji: '💼' },
  { id: 'souvenirs',label: 'Souvenirs',          emoji: '🧸' },
  { id: 'noel',     label: 'Noël',               emoji: '🎄' },
  { id: 'vacances', label: 'Vacances',           emoji: '🏖️' },
  { id: 'soirees',  label: 'Les soirées',        emoji: '🎉' },
  { id: 'droles',   label: 'Photos drôles',      emoji: '😂' },
  { id: 'amour',    label: "L'amour",            emoji: '💕' },
];

window.TP = TP;
window.CATEGORIES = CATEGORIES;
